import { all, fork, spawn } from 'redux-saga/effects';
import {
  watchAllocationBulkActionSaga,
  watchUpdateAllocatedMemberSaga,
} from './allocation';
import { watchAllAutomationsSaga } from './automations';
import { watchTemplateDateShiftSaga } from './date-shift';
import {
  watchGetDynamicTemplatePreviewSaga,
  watchUpdateDynamicTemplateConditionsSaga,
} from './dynamic-template';
import { watchFetchProjectTemplateSaga } from './fetch';
import { watchUpdateJiraMappingsInTemplateSaga } from './jira';
import { projectPhaseTemplateRootSaga } from './project-phase';
import {
  // watchSaveProjectTemplateDraftSaga,
  watchSaveProjectTemplateSaga,
} from './save';
import { spaceTemplateRootSaga } from './space';
import { watchCreateSubTaskInTemplateSagaSaga } from './sub-task';
import { taskTemplateRootSaga } from './task';

export function* projectTemplateRootSaga(): Generator {
  yield all([
    fork(watchFetchProjectTemplateSaga),
    fork(watchSaveProjectTemplateSaga),
    fork(projectPhaseTemplateRootSaga),
    fork(taskTemplateRootSaga),
    fork(watchCreateSubTaskInTemplateSagaSaga),
    fork(spaceTemplateRootSaga),
    fork(watchUpdateJiraMappingsInTemplateSaga),
    fork(watchUpdateDynamicTemplateConditionsSaga),
    fork(watchGetDynamicTemplatePreviewSaga),
    fork(watchAllocationBulkActionSaga),
    fork(watchUpdateAllocatedMemberSaga),
    fork(watchAllAutomationsSaga),
    spawn(watchTemplateDateShiftSaga),
  ]);
}
